interface MoodPlaylist {
    id: string;
    name: string;
}
